import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { StrategyEx } from "@front/m19-models";
import { IIconComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspCreativeTypeDescriptions } from "@m19-board/dsp/dsp-creatives/dsp-creative-type-selector/dsp-creative-type-selector.component";

@Component({
  selector: "app-strategy-grid-creative-type",
  imports: [TranslocoDirective, IIconComponent],
  host: {
    class: "flex items-center gap-1",
  },
  template: `
    @if (dspStrategy(); as dspStrategy) {
      <IIcon [name]="DspCreativeTypeDescriptions[dspStrategy.creativeType!]?.icon ?? 'video'" />
      <span class="ml-1 text-gray-500" *transloco="let t">
        {{ t(DspCreativeTypeDescriptions[dspStrategy.creativeType!]?.title ?? "dsp-creative-type-selector.video") }}
      </span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyGridDspCreativeTypeComponent {
  protected readonly DspCreativeTypeDescriptions = DspCreativeTypeDescriptions;

  readonly strategy = input.required<StrategyEx>();

  readonly dspStrategy = computed(() => {
    const strategy = this.strategy();
    return strategy.isDspStrategy() ? strategy : null;
  });
}
